import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {DynXyzAppHeaderComponent} from '../dynamic-xyz/dyn-xyz-app-header/dyn-xyz-app-header.component';
import {DynamicZyxGlobalDaemonModule} from '../dynamic-xyz/dynamic-zyx-global-daemon.module';
import {LanguageSelectorModule} from '../language-selector';
import {LinkToSimulatorModule} from '../link-to-simulator';
import {MainMenuModule} from '../main-menu/main-menu.module';
import {TooltipModule} from '../tooltip/index';
import {AppHeaderComponent} from './app-header.component';

@NgModule({
    imports: [
        CommonModule,
        LanguageSelectorModule,
        MainMenuModule,
        LinkToSimulatorModule,
        DynXyzAppHeaderComponent,
        DynamicZyxGlobalDaemonModule,
        TooltipModule
    ],
    declarations: [
        AppHeaderComponent
    ],
    exports: [
        AppHeaderComponent
    ]
})
export class AppHeaderModule {}
